import { useState, useEffect } from "react";
import "../GameUI.css";
import Level2 from "./Level2";
import Level3 from "./Level3";
import Level4 from "./Level4";
import EndGame from "./EndGame";



const GameUI = () => {
  const [currentLevel, setCurrentLevel] = useState(() => Number(localStorage.getItem('currentLevel') || 1));
  useEffect(() => { localStorage.setItem('currentLevel', String(currentLevel)); }, [currentLevel]);
  
  // Salviamo gli “score” o le statistiche di ogni livello in uno stato dedicato.
  // Puoi usare un oggetto unico o più stati separati, a tuo piacere.
  const [level2Stats, setLevel2Stats] = useState(() => JSON.parse(localStorage.getItem('level2Stats') || 'null'));
  const [level3Stats, setLevel3Stats] = useState(() => JSON.parse(localStorage.getItem('level3Stats') || 'null'));
  const [level4Stats, setLevel4Stats] = useState(() => JSON.parse(localStorage.getItem('level4Stats') || 'null'));
  useEffect(() => localStorage.setItem('level2Stats', JSON.stringify(level2Stats)), [level2Stats]);
  useEffect(() => localStorage.setItem('level3Stats', JSON.stringify(level3Stats)), [level3Stats]);
  useEffect(() => localStorage.setItem('level4Stats', JSON.stringify(level4Stats)), [level4Stats]);

  console.log("GameUI - Level2Stats:", level2Stats);
  console.log("GameUI - Level3Stats:", level3Stats);
  console.log("GameUI - Level4Stats:", level4Stats);

  const handleNextLevel = () => {
    setCurrentLevel((prevLevel) => prevLevel + 1);
  };

  // Se hai solo 3 livelli e il next level va oltre il 3, rendi EndGame:
  if (currentLevel > 3) {
    return (
      <EndGame
        level2Stats={level2Stats}
        level3Stats={level3Stats}
        level4Stats={level4Stats}
      />
    );
  }

  return (
    <>
      {currentLevel === 1 && (
        <Level2
          // Quando il livello 2 termina, “ritorna” i dati chiamando onfinis
          onFinish={(stats) => {
            setLevel2Stats(stats);
            handleNextLevel();
          }}
        />
      )}

      {currentLevel === 2 && (
        <Level3
          onFinish={(stats) => {
            setLevel3Stats(stats);
            handleNextLevel();
          }}
        />
      )}

      {currentLevel === 3 && (
        <Level4
          onFinish={(stats) => {
            setLevel4Stats(stats);
            handleNextLevel();
          }}
        />
      )}
    </>
  );
};


export default GameUI;
